export type InspectionRequestPreferenceMeridiem =
  (typeof InspectionRequestPreferenceMeridiems)[keyof typeof InspectionRequestPreferenceMeridiems];

export const InspectionRequestPreferenceMeridiems = {
  AM: "AM",
  PM: "PM",
} as const;

export const AM = InspectionRequestPreferenceMeridiems.AM;
export const PM = InspectionRequestPreferenceMeridiems.PM;
